/**
 * @generated SignedSource<<ba65436667fe8908de42e34d716e72c5>>
 * @relayHash ec63860bcf7d621bac5934b705b98937
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID ec63860bcf7d621bac5934b705b98937

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sirets"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sirets",
        "variableName": "sirets"
      }
    ],
    "concreteType": "LegalPerson",
    "kind": "LinkedField",
    "name": "legalPersons",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "codeApplication",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "identifiantDansSilo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siret",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getLegalPersonsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getLegalPersonsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ec63860bcf7d621bac5934b705b98937",
    "metadata": {},
    "name": "getLegalPersonsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "12ca36dea2c5b9466072ffc65abf1bbd";

export default node;
